// extracted by mini-css-extract-plugin
export default {"soldOutLabel":"xt2zAU","container":"GjQZ9z"};